import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FormControl } from 'react-bootstrap';
import actions from '../../redux/actions';
import { getMemberNameByUserId } from '../../utils';

class DealMessage extends Component {
  constructor() {
    super();
    this.state = {
      message: '',
    };
  }

  componentWillMount() {
    this.props.loadDealMessages(this.props.deal.id);
  }

  componentDidUpdate(prevProps) {
    this.refs.messagesList.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
    });
  }

  getUserName(id) {
    const userName = getMemberNameByUserId(id, this.props.members);
    if (!userName) {
      return 'Noname';
    }
    return userName;
  }

  getMessages() {
    if (this.props.messages) {
      return this.props.messages.map((message, i) => (
        <div key={i} className="message">
          <a className="user">{this.getUserName(message.user)}: </a>
          <span
            dangerouslySetInnerHTML={{
              __html: message.message.replace(/\n/g, '<br />'),
            }}
          />
        </div>
      ));
    }
  }

  handleSend(e) {
    e.preventDefault();

    const { deal, profile } = this.props;
    const { message } = this.state;
    const notifiers = [];

    if (message.trim()) {
      this.props.sendDealMessage({
        deal: deal.id,
        user: profile.id,
        notifiers,
        message,
      });
      this.setState({ message: '' });
    }
  }

  handleInput(e) {
    if (e.keyCode === 13 && e.ctrlKey) {
      this.handleSend(e);
    }
  }

  handleChange(e) {
    this.setState({ message: e.target.value });
  }

  render() {
    return (
      <div className="messages">
        <div className="message-list">
          {this.getMessages()}
          <div ref="messagesList" />
        </div>

        <div className="input">
          <FormControl
            ref="input"
            componentClass="textarea"
            value={this.state.message}
            onKeyDown={(e) => this.handleInput(e)}
            onChange={(e) => this.handleChange(e)}
            placeholder="Want to chat with your collaborators about this agreement? Start typing here."
          />
          <button onClick={(e) => this.handleSend(e)}>Send</button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  profile: state.profile,
  deal: state.deals.selectedDeal,
  members: state.users.members,
  status: state.dealMessages.status,
  messages: state.dealMessages.messages,
});

const mapDispatchToProps = (dispatch) => ({
  alert: (type, msg) => {
    dispatch(actions.alert(type, msg));
  },
  hideAlert: () => {
    dispatch(actions.hideAlert());
  },
  loadDealMessages: (dealId) => {
    dispatch(actions.getDealMessages(dealId));
  },
  sendDealMessage: (message) => {
    dispatch(actions.sendDealMessage(message));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(DealMessage);



// WEBPACK FOOTER //
// src/components/Deals/Message.jsx